/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_DataInputs */

const en_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge & Data`)
};

const zh_hans1_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`知识与数据`)
};

const pt_br2_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conhecimento e dados`)
};

const es_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conocimiento y datos`)
};

const fr_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connaissances et données`)
};

const de_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissen & Daten`)
};

const ru_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знания и данные`)
};

const it_category_data = /** @type {(inputs: Category_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoscenza e dati`)
};

/**
* | output |
* | --- |
* | "Knowledge & Data" |
*
* @param {Category_DataInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_data = /** @type {((inputs?: Category_DataInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_DataInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_data(inputs)
	if (locale === "pt-BR") return pt_br2_category_data(inputs)
	if (locale === "es") return es_category_data(inputs)
	if (locale === "fr") return fr_category_data(inputs)
	if (locale === "de") return de_category_data(inputs)
	if (locale === "ru") return ru_category_data(inputs)
	if (locale === "it") return it_category_data(inputs)
	return en_category_data(inputs)
});